import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IAccountDataFormMeta {
    accountType: FormInputMeta;
    accountStatus: FormInputMeta;
    accountCurrency: FormInputMeta;
    creationDate: FormInputMeta;
    effectiveDate: FormInputMeta;
    endDate: FormInputMeta;

    schema: any;
}

const accountDataFormMeta = {} as IAccountDataFormMeta;

accountDataFormMeta.accountType = {
    name: "accountType",
    type: "select",
    label: "Type Compte",
    placeholder: "",
    validation: yup.string(),
};

accountDataFormMeta.accountStatus = {
    name: "accountStatus",
    type: "select",
    label: "Statut Compte",
    placeholder: "",
    validation: yup.string(),
};

accountDataFormMeta.accountCurrency = {
    name: "accountCurrency",
    type: "select",
    label: "Monnaie Compte",
    placeholder: "",
    validation: yup.string(),
};

accountDataFormMeta.creationDate = {
    name: "creationDate",
    type: "date",
    label: "Date Création",
    placeholder: "",
    validation: yup.string(),
};

accountDataFormMeta.effectiveDate = {
    name: "effectiveDate",
    type: "date",
    label: "Date Effective",
    placeholder: "",
    validation: yup.string(),
};

accountDataFormMeta.endDate = {
    name: "endDate",
    type: "date",
    label: "Date Finale",
    placeholder: "",
    validation: yup.string(),
};


accountDataFormMeta.schema = yup.object().shape(getValidationSchema(accountDataFormMeta));

export default accountDataFormMeta;